// @ts-expect-error TS7016
import { remove as removeDiacritics } from "diacritics";

import { isAlphaNumeric } from "utils/string";

const badCharsBeforeEscapeGlobal = /[&<>"'`=]/g;
const badCharsBeforeEscape = /[&<>"'`=]/;
const escapeCharsMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#x27;",
  "`": "&#x60;",
  "=": "&#x3D;",
};

function escapeBadChar(char: string): string {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return escapeCharsMap[char];
}

/**
 * Escapes HTML entities in string.
 *
 * Function borrowed from Handlebars Utils:
 * https://github.com/wycats/handlebars.js/blob/7535e48a7969229f44489124a8ef07bd17363f06/lib/handlebars/utils.js#L64
 */
export function escapeString(string: string): string {
  if (!badCharsBeforeEscape.test(string)) {
    return string;
  }

  return string.replace(badCharsBeforeEscapeGlobal, escapeBadChar);
}

/*
 * Return formatted number with separators and comas ex. 123456.789 -> 123,456.789
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFormattedNumberValue(value: any): string {
  if (typeof value === "number") {
    return value.toLocaleString("en-EN");
  }
  return value;
}

export function formatStringToDomain(input: string): string {
  return removeDiacritics(input)
    .replace(/ +/g, "-")
    .toLocaleLowerCase()
    .split("")
    .filter((letter: string) => isAlphaNumeric(letter) || letter === "-")
    .join("");
}

const spaceRegexp = / /g;
export function replaceSpaceWithNbsp(s: string): string {
  return s.replace(spaceRegexp, "\u00A0");
}

export const replaceWithSubstring = (
  str: string,
  startPhrase: string,
  endPhrase: string,
  replacement: string
): string => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const escapeRegExp = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return str.replace(new RegExp(`${escapeRegExp(startPhrase)}.*?${escapeRegExp(endPhrase)}`, "g"), replacement);
};
